import styled from "@emotion/styled";
import { CalendarCell } from "react-aria-components";

export const StyledCalendarCell = styled(CalendarCell)`
  width: 2.286rem;
  line-height: 2.286rem;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  outline: none;
  forced-color-adjust: none;
  font-size: 0.875rem;

  &[data-hovered] {
    background: ${({ theme }) => theme.colors.background.button.default.hover};
  }

  &[data-pressed] {
    background: ${({ theme }) => theme.colors.background.button.default.hover};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  &[data-selected] {
    background: ${({ theme }) => theme.colors.background.button.default.default};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &[data-disabled],
  &[data-unavailable],
  &[data-invalid] {
    cursor: none;
    pointer-events: none;
    opacity: 0.6;
  }

  &[data-outside-month] {
    background: none;
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`;
